import { takeLatest, put, call } from "redux-saga/effects";
import {
  fetchPesoTimeDepositRates,
  fetchLongTermPesoTimeDepositRates,
  fetchLongTermPesoTimeDepositRatesFloating,
  fetchUSDTimeDepositRate,
  fetchLongTermUSDTimeDepositRate,
  fetchTimeDepositRatesValidity,
  fetchRmbTimeDepositRate,
  fetchEuroTimeDepositRate,
  fetchJPYTimeDepositRate,
  fetchSGDDepositRate,
  fetchAUDTimeDepositRate,
} from "network/services/rates";
import { ISaga, PayloadType } from "../types";
import {
  fetchTimeDepositRatesSuccess,
  fetchTimeDepositRateFailed,
} from "../actionCreators";

const transformData = (data) => {
  return data.map((item) => {
    item.title = item.title.replace(/&lt;/g, "<");
    return item;
  });
};

function* processFetchTimeDepositRates(): ISaga {
  try {
    const { data: pesoTimeDeposit } = yield call(fetchPesoTimeDepositRates);
    const { data: longTermPesoTimeDeposit } = yield call(
      fetchLongTermPesoTimeDepositRates
    );
    const { data: longTermPesoTimeDepositFloating } = yield call(
      fetchLongTermPesoTimeDepositRatesFloating
    );
    const { data: usdTimeDepositRates } = yield call(fetchUSDTimeDepositRate);

    const { data: longTermUsdTimeDepositRates } = yield call(
      fetchLongTermUSDTimeDepositRate
    );

    const { data: rmbDepositRates } = yield call(fetchRmbTimeDepositRate);

    const { data: euroTimeDepositRate } = yield call(fetchEuroTimeDepositRate);

    const { data: timedepositratesvalidity } = yield call(
      fetchTimeDepositRatesValidity
    );
    const { data: sgdTimeDepositRates } = yield call(fetchSGDDepositRate);

    const { data: jpyTimeDepositRates } = yield call(fetchJPYTimeDepositRate);

    const { data: audTimeDepositRates } = yield call(fetchAUDTimeDepositRate);

    let payload: PayloadType = {
      audTimeDepositRates: transformData(audTimeDepositRates),
      rmbDepositRates: transformData(rmbDepositRates),
      pesoTimeDeposit: transformData(pesoTimeDeposit),
      longTermPesoTimeDeposit: transformData(longTermPesoTimeDeposit),
      longTermPesoTimeDepositFloating: transformData(
        longTermPesoTimeDepositFloating
      ),
      usdTimeDepositRates: transformData(usdTimeDepositRates),
      longTermUsdTimeDepositRates: transformData(longTermUsdTimeDepositRates),
      euroTimeDepositRates: transformData(euroTimeDepositRate),
      jpyTimeDepositRates: transformData(jpyTimeDepositRates),
      sgdTimeDepositRates: transformData(sgdTimeDepositRates),
      timedepositratesvalidity,
    };

    yield put(fetchTimeDepositRatesSuccess(payload));
  } catch (e) {
    console.error("FETCHING TIME DEPOSIT RATES ERROR", e);
    yield put(fetchTimeDepositRateFailed());
  }
}

export default function* watcher() {
  yield takeLatest("REQUEST_TIME_DEPOSIT_DATA", processFetchTimeDepositRates);
}
